import { Reducer, AnyAction } from 'redux';

export const SET_LOADING_ACTION = {
  SET_LOADING: 'loading/SET_LOADING_ACTION',
};

export const setLoadingAction = (isLoading: boolean) => ({
  type: SET_LOADING_ACTION.SET_LOADING,
  payload: { isLoading },
});

export interface LoadingState {
  isLoading: boolean;
};

const initialState: LoadingState = {
  isLoading: false,
};

export const loadingReducer: Reducer<LoadingState, AnyAction> = (currentState: LoadingState = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_LOADING_ACTION.SET_LOADING: {
      const { isLoading } = action.payload;
      return {
        isLoading,
      };
    }
    default:
      return currentState;
  }
};
